const STEPS = [
  {
    n: "01",
    title: "Prise de contrôle rapide",
    desc: "Quelques jours pour lire honnêtement la situation : équipes, contrats, projets, gouvernance, dette, risques. Décisions posées, priorités arbitrées, cadre rétabli.",
  },
  {
    n: "02",
    title: "Stabilisation / sécurisation",
    desc: "Remise sous contrôle des engagements critiques et sécurisation de la continuité de service. Le SI tient, les équipes respirent, la direction est rassurée.",
  },
  {
    n: "03",
    title: "Transmission en ordre de marche",
    desc: "Gouvernance stabilisée, feuille de route claire, recrutement éventuel du DSI pérenne. Une DSI transmise en ordre de marche, pas un dossier à refermer.",
  },
];

export default function Method() {
  return (
    <section
      id="methode"
      data-testid="method-section"
      className="py-24 sm:py-36 px-6 sm:px-10 lg:px-16 bg-[#FAF8F5]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal max-w-3xl mb-20">
          <p className="eyebrow flex items-center mb-6">
            <span className="gold-line" />
            Mode d'intervention
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.1]">
            Trois temps. <span className="italic">Pas un de plus.</span>
          </h2>
          <p className="mt-6 text-[#4A5568] leading-relaxed font-light text-lg">
            Une méthode simple, qui privilégie l'exécution sur la théorie,
            et la décision sur la documentation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#E2DCD0] border border-[#E2DCD0]">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`method-step-${i}`}
              className="reveal bg-[#FAF8F5] p-10 sm:p-14 relative"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <span className="method-num text-7xl sm:text-8xl text-[#C8A97E]/40 block mb-6">
                {s.n}
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl text-[#0B132B] mb-5 leading-tight">
                {s.title}
              </h3>
              <p className="text-[#4A5568] leading-relaxed font-light">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
